export function assert(condition: unknown): asserts condition {
    if (condition === undefined || condition === null) {
        throw new Error('condition is not satisfied');
    }
}
